export default __webpack_public_path__ + "static/media/pinterest.ff6b507c.svg";